import { Pipe, PipeTransform } from '@angular/core';

import { formatRelativeDatetime } from '@innersight-os/shared/util';

@Pipe({
    name: 'relativeDatetime',
    standalone: false
})
export class RelativeDatetimePipe implements PipeTransform {
  transform(date: Date): string {
    return formatRelativeDatetime(date);
  }
}
